// src/App.js
import React, { useContext } from 'react';
import { WalletProvider } from './contexts/WalletContext.js';
import { ContractProvider } from './contexts/ContractContext.js';
import { WalletContext } from './contexts/WalletContext.js';
import Header from './components/Header.js';
import WalletConnect from './components/WalletConnect.js';
import Tabs from './components/ui/Tabs.js';
import ExplorePools from './pages/ExplorePools.js';
import CreatePool from './pages/CreatePool.js';
import MyPools from './pages/MyPools.js';
import MyEntries from './pages/MyEntries.js';
import './assets/styles/global.css';

const AppContent = () => {
  const { account } = useContext(WalletContext);

  // Only show app content if wallet is connected
  if (!account) {
    return (
      <div className="container">
        <WalletConnect />
      </div>
    );
  }

  const tabs = [
    { label: 'Explore Pools', content: <ExplorePools /> },
    { label: 'Create Pool', content: <CreatePool /> },
    { label: 'My Pools', content: <MyPools /> },
    { label: 'My Entries', content: <MyEntries /> }
  ];

  return (
    <div className="container">
      <WalletConnect />
      <Tabs tabs={tabs} initialTab={0} />
    </div>
  );
};

const App = () => {
  return (
    <WalletProvider>
      <ContractProvider>
        <Header />
        <AppContent />
      </ContractProvider>
    </WalletProvider>
  );
};

export default App;